import { PaginationData } from '@/shared/models/api-response.interface';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
})
export class PaginationComponent implements OnChanges {
  @Input() paginationData!: PaginationData | undefined;
  @Input() hasPerPageSelector: boolean = true;
  @Output() onPageConfigsChange = new EventEmitter<{
    page: number;
    perPage: number;
  }>();

  perPageOptions: number[] = [6, 8, 10, 20, 30, 50];
  itemsPerPage: number = this.perPageOptions[0];
  currentPage: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['paginationData'] && this.paginationData) {
      this.currentPage = this.paginationData.pageable.pageNumber;
      this.itemsPerPage = this.paginationData.pageable.pageSize;
    }
  }

  onItemsPerPageChange() {
    this.onPageConfigsChange.emit({
      page: this.currentPage,
      perPage: this.itemsPerPage,
    });
  }

  changeItemsPerPage(perPage: number) {
    this.itemsPerPage = perPage;
    this.onPageConfigsChange.emit({
      page: this.currentPage,
      perPage: this.itemsPerPage,
    });
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.onPageConfigsChange.emit({
      page: this.currentPage,
      perPage: this.itemsPerPage,
    });
  }
}
